import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      nav: {
        dashboard: 'Dashboard',
        families: 'Families',
        todos: 'Todo Boards',
        documents: 'Documents',
        passwords: 'Passwords',
        shopping: 'Shopping',
        calendar: 'Calendar',
        settings: 'Settings',
        logout: 'Logout',
      },
      auth: {
        welcomeBack: 'Welcome Back',
        signInSubtitle: 'Sign in to your account to continue',
        usernameOrEmail: 'Username or Email',
        password: 'Password',
        signIn: 'Sign In',
        noAccount: "Don't have an account?",
        createOne: 'Create one',
        createAccount: 'Create Account',
        joinSubtitle: 'Join MyFamily and start organizing together',
        firstName: 'First Name',
        lastName: 'Last Name',
        email: 'Email',
        username: 'Username',
        confirmPassword: 'Confirm Password',
        register: 'Create Account',
        haveAccount: 'Already have an account?',
        signInHere: 'Sign in',
        creating: 'Creating account...',
        loginFailed: 'Login failed',
        registrationFailed: 'Registration failed',
        accountCreated: 'Account created successfully!',
      },
      register: {
        title: 'Create Account',
        subtitle: 'Join MyFamily and start organizing together',
        firstName: 'First Name',
        lastName: 'Last Name',
        email: 'Email',
        username: 'Username',
        password: 'Password',
        confirmPassword: 'Confirm Password',
        create: 'Create Account',
        haveAccount: 'Already have an account?',
        signIn: 'Sign in',
        required: 'Required',
        emailRequired: 'Email is required',
        emailInvalid: 'Invalid email address',
        usernameRequired: 'Username is required',
        usernameMin: 'Username must be at least 3 characters',
        passwordRequired: 'Password is required',
        passwordMin: 'Password must be at least 8 characters',
        confirmRequired: 'Please confirm your password',
        confirmMismatch: 'Passwords do not match',
        creating: 'Creating account...',
      },
      dashboard: {
        greetingMorning: 'Good morning',
        greetingAfternoon: 'Good afternoon',
        greetingEvening: 'Good evening',
        noFamily: 'No family yet',
        createFamilyCta: 'Create Family',
        quickActions: {
          todos: 'Todo Boards',
          documents: 'Documents',
          passwords: 'Passwords',
          shopping: 'Shopping',
          calendar: 'Calendar',
          families: 'Families',
        },
        recentActivity: 'Recent Activity',
        noActivity: 'No recent activity',
        activityHint: "Your family's activity will appear here",
      },
      families: {
        title: 'Families',
        subtitle: 'Manage your family groups',
        create: 'Create Family',
        noneTitle: 'No families yet',
        noneDesc: 'Create your first family or ask someone to invite you',
        nameLabel: 'Family Name',
        descLabel: 'Description (optional)',
        descPlaceholder: 'A brief description of your family',
        cancel: 'Cancel',
        creating: 'Creating...',
        createCta: 'Create',
        selectFamily: 'Go to Families',
        membersCount: '{{count}} member',
        membersCount_plural: '{{count}} members',
        toastCreated: 'Family created successfully!',
        toastCreateFail: 'Failed to create family',
      },
      familyDetail: {
        setCurrent: 'Set as Current',
        invite: 'Invite',
        addMember: 'Add Member',
        members: 'Members',
        managed: 'managed',
        simpleUI: 'simple UI',
        inviteTitle: 'Invite Member',
        inviteCopy: 'Share this link:',
        inviteExpires: 'This link expires in 7 days',
        addManagedTitle: 'Add Family Member',
        addManagedDesc: "Add a family member who doesn't have an account yet. They can link later.",
        name: 'Name',
        role: 'Role',
        uiMode: 'UI Mode',
        emailOptional: 'Email (optional)',
        color: 'Color',
        cancel: 'Cancel',
        add: 'Add Member',
        settingsTitle: 'Member Settings',
        nickname: 'Nickname',
        remove: 'Remove',
        save: 'Save',
        toastInviteFail: 'Failed to create invite',
        toastCopied: 'Link copied to clipboard!',
        toastDelete: 'Family deleted',
        toastDeleteFail: 'Failed to delete family',
        toastAddMember: 'Family member added!',
        toastAddMemberFail: 'Failed to add member',
        toastUpdate: 'Member updated!',
        toastUpdateFail: 'Failed to update member',
        toastRemove: 'Member removed',
        toastRemoveFail: 'Failed to remove member',
        deleteConfirm: 'Are you sure you want to delete "{{name}}"? This cannot be undone.',
        removeConfirm: 'Remove this member from the family?',
        currentSet: 'set as current family',
      },
      join: {
        title: 'Family Invitation',
        subtitle: "You've been invited to join a family on MyFamily",
        accept: 'Accept Invitation',
        joining: 'Joining...',
        pleaseSignIn: 'Please sign in or create an account to join',
        signIn: 'Sign In',
        register: 'Register',
        backHome: 'Back to Home',
        success: 'You have joined the family!',
        fail: 'Failed to join family',
      },
      todoBoards: {
        title: 'Todo Boards',
        noneTitle: 'No Boards Yet',
        noneDesc: 'Create your first todo board',
        newBoard: 'New Board',
        createBoard: 'Create Board',
        boardName: 'Board Name',
        boardDesc: 'Description',
        boardDescPlaceholder: "What's this board for?",
        noFamilyTitle: 'No Family Selected',
        noFamilyDesc: 'Select or create a family to manage todo boards',
        goFamilies: 'Go to Families',
        toastCreated: 'Board created!',
        toastCreateFail: 'Failed to create board',
      },
      todoBoard: {
        addTask: 'Add Task',
        filters: {
          all: 'All',
          todo: 'To Do',
          done: 'Done',
        },
        emptyDoneTitle: 'No completed tasks',
        emptyDoneDesc: 'Complete some tasks to see them here',
        emptyTitle: 'No tasks yet',
        emptyDesc: 'Add your first task to get started',
        addTaskCta: 'Add Task',
        assignedTo: 'Assigned to {{name}}',
        due: 'Due {{date}}',
        modalTitle: 'Add Task',
        taskTitle: 'Task Title',
        description: 'Description',
        priority: 'Priority',
        low: 'Low',
        medium: 'Medium',
        high: 'High',
        urgent: 'Urgent',
        cancel: 'Cancel',
        create: 'Create',
        toastAdded: 'Task added!',
        toastAddFail: 'Failed to add task',
        toastDelete: 'Task deleted',
      },
      shoppingLists: {
        title: 'Shopping Lists',
        noneTitle: 'No Shopping Lists',
        noneDesc: 'Create your first shopping list',
        newList: 'New List',
        createList: 'Create List',
        listName: 'List Name',
        store: 'Store (optional)',
        color: 'Color',
        noFamilyTitle: 'No Family Selected',
        noFamilyDesc: 'Select or create a family to manage shopping lists',
        goFamilies: 'Go to Families',
        toastCreated: 'List created!',
        toastCreateFail: 'Failed to create list',
        completed: 'Completed',
        itemsCount: '{{checked}}/{{total}} items',
      },
      shoppingList: {
        progress: '{{checked}} of {{total}} items',
        quickAddPlaceholder: 'Add item...',
        emptyTitle: 'List is empty',
        emptyDesc: 'Add some items to your shopping list',
        toBuy: 'To Buy',
        completed: 'Completed ({{count}})',
        addedBy: 'by {{name}}',
        notes: 'Notes',
        category: 'Category',
        quantityUnit: '× {{quantity}} {{unit}}',
        modalTitle: 'Add Item',
        itemName: 'Item name',
        quantity: 'Quantity',
        unit: 'Unit',
        notesLabel: 'Notes',
        cancel: 'Cancel',
        add: 'Add',
        toastAdded: 'Item added!',
        toastRemoved: 'Item removed',
      },
      documents: {
        title: 'Documents',
        upload: 'Upload',
        searchPlaceholder: 'Search documents...',
        noneTitle: 'No Documents',
        noneDesc: 'Upload your first document',
        uploadCta: 'Upload Document',
        noFamilyTitle: 'No Family Selected',
        noFamilyDesc: 'Select or create a family to manage documents',
        goFamilies: 'Go to Families',
        uploadedBy: 'by {{name}}',
        toastUploaded: 'Document uploaded!',
        toastUploadFail: 'Upload failed',
        toastDelete: 'Document deleted',
        toastDownloadFail: 'Download failed',
        modalTitle: 'Upload Document',
        selectFile: 'Select a file to upload',
        uploading: 'Uploading...',
        cancel: 'Cancel',
        uploadBtn: 'Upload',
      },
      passwords: {
        title: 'Password Vault',
        searchPlaceholder: 'Search passwords...',
        noneTitle: 'No Passwords',
        noneDesc: 'Add your first password entry',
        addPassword: 'Add Password',
        noFamilyTitle: 'No Family Selected',
        noFamilyDesc: 'Select or create a family to manage passwords',
        goFamilies: 'Go to Families',
        reveal: 'Reveal',
        hide: 'Hide',
        toastSaved: 'Password saved!',
        toastSaveFail: 'Failed to save password',
        toastDelete: 'Password deleted',
        toastCopy: 'Copied to clipboard!',
        toastGenerate: 'Password generated!',
        toastRevealFail: 'Failed to reveal password',
        modalTitle: 'Add Password',
        name: 'Name',
        username: 'Username',
        email: 'Email',
        password: 'Password',
        url: 'URL',
        category: 'Category',
        cancel: 'Cancel',
        save: 'Save',
        generate: 'Generate',
      },
      calendar: {
        title: 'Calendar',
        addEvent: 'Add Event',
        noFamilyTitle: 'No Family Selected',
        noFamilyDesc: 'Select or create a family to view calendar',
        goFamilies: 'Go to Families',
        monthLabel: '{{month}} {{year}}',
        dayNames: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        noEvents: 'No events scheduled',
        googleTitle: 'Google Calendar Integration',
        googleDesc: 'Connect your Google Calendar to sync events with your family calendar.',
        connectGoogle: 'Connect Google Calendar',
      },
      notFound: {
        title: 'Page Not Found',
        desc: "The page you're looking for doesn't exist or has been moved.",
        backHome: 'Back to Home',
      },
      authLayout: {
        brand: 'MyFamily',
        tagline: 'Family Management',
        footer: '© 2024 MyFamily. All rights reserved.',
      },
      common: {
        settings: 'Settings',
        manageAccount: 'Manage your account and preferences',
        logout: 'Log Out',
        appInfo: 'MyFamily v1.0.0',
        madeWithLove: 'Made with ❤️ for families',
      },
      settings: {
        account: 'Account',
        preferences: 'Preferences',
        devices: 'Devices',
        editProfile: 'Edit Profile',
        editProfileDesc: 'Update your name, email, and avatar',
        changePassword: 'Change Password',
        changePasswordDesc: 'Update your account password',
        notifications: 'Notifications',
        notificationsDescOn: 'Enabled',
        notificationsDescOff: 'Disabled',
        darkMode: 'Dark Mode',
        darkModeDesc: 'Always on',
        theme: 'Theme',
        themeDesc: 'Switch light/warm or dark',
        themeLight: 'Light (warm)',
        themeDark: 'Dark',
        save: 'Save',
        language: 'Language',
        languageDesc: 'Choose your language',
        manageDevices: 'Manage Devices',
        manageDevicesDesc: 'View and manage connected devices',
        languageLabel: 'Language',
        languages: {
          en: 'English',
          pl: 'Polish',
          uk: 'Ukrainian',
        },
      },
    },
  },
  pl: {
    translation: {
      nav: {
        dashboard: 'Panel',
        families: 'Rodziny',
        todos: 'Tablice zadań',
        documents: 'Dokumenty',
        passwords: 'Hasła',
        shopping: 'Zakupy',
        calendar: 'Kalendarz',
        settings: 'Ustawienia',
        logout: 'Wyloguj',
      },
      auth: {
        welcomeBack: 'Witamy ponownie',
        signInSubtitle: 'Zaloguj się, aby kontynuować',
        usernameOrEmail: 'Nazwa użytkownika lub email',
        password: 'Hasło',
        signIn: 'Zaloguj',
        noAccount: 'Nie masz konta?',
        createOne: 'Utwórz je',
        createAccount: 'Utwórz konto',
        joinSubtitle: 'Dołącz do MyFamily i zacznij organizować',
        firstName: 'Imię',
        lastName: 'Nazwisko',
        email: 'Email',
        username: 'Nazwa użytkownika',
        confirmPassword: 'Potwierdź hasło',
        register: 'Utwórz konto',
        haveAccount: 'Masz już konto?',
        signInHere: 'Zaloguj się',
        creating: 'Tworzenie konta...',
        loginFailed: 'Logowanie nieudane',
        registrationFailed: 'Rejestracja nieudana',
        accountCreated: 'Konto utworzone pomyślnie!',
      },
      register: {
        title: 'Utwórz konto',
        subtitle: 'Dołącz do MyFamily i zacznij organizować',
        firstName: 'Imię',
        lastName: 'Nazwisko',
        email: 'Email',
        username: 'Nazwa użytkownika',
        password: 'Hasło',
        confirmPassword: 'Potwierdź hasło',
        create: 'Utwórz konto',
        haveAccount: 'Masz już konto?',
        signIn: 'Zaloguj się',
        required: 'Wymagane',
        emailRequired: 'Email jest wymagany',
        emailInvalid: 'Nieprawidłowy adres email',
        usernameRequired: 'Nazwa użytkownika jest wymagana',
        usernameMin: 'Minimum 3 znaki',
        passwordRequired: 'Hasło jest wymagane',
        passwordMin: 'Minimum 8 znaków',
        confirmRequired: 'Potwierdź hasło',
        confirmMismatch: 'Hasła nie są zgodne',
        creating: 'Tworzenie konta...',
      },
      dashboard: {
        greetingMorning: 'Dzień dobry',
        greetingAfternoon: 'Dzień dobry',
        greetingEvening: 'Dobry wieczór',
        noFamily: 'Brak rodziny',
        createFamilyCta: 'Utwórz rodzinę',
        quickActions: {
          todos: 'Tablice zadań',
          documents: 'Dokumenty',
          passwords: 'Hasła',
          shopping: 'Zakupy',
          calendar: 'Kalendarz',
          families: 'Rodziny',
        },
        recentActivity: 'Ostatnia aktywność',
        noActivity: 'Brak ostatniej aktywności',
        activityHint: 'Aktywność Twojej rodziny pojawi się tutaj',
      },
      families: {
        title: 'Rodziny',
        subtitle: 'Zarządzaj swoimi grupami rodzinnymi',
        create: 'Utwórz rodzinę',
        noneTitle: 'Brak rodzin',
        noneDesc: 'Utwórz pierwszą rodzinę lub poproś o zaproszenie',
        nameLabel: 'Nazwa rodziny',
        descLabel: 'Opis (opcjonalnie)',
        descPlaceholder: 'Krótki opis rodziny',
        cancel: 'Anuluj',
        creating: 'Tworzenie...',
        createCta: 'Utwórz',
        selectFamily: 'Przejdź do rodzin',
        membersCount: '{{count}} członek',
        membersCount_plural: '{{count}} członków',
        toastCreated: 'Rodzina utworzona!',
        toastCreateFail: 'Nie udało się utworzyć rodziny',
      },
      familyDetail: {
        setCurrent: 'Ustaw jako aktualną',
        invite: 'Zaproś',
        addMember: 'Dodaj członka',
        members: 'Członkowie',
        managed: 'zarządzany',
        simpleUI: 'prosty interfejs',
        inviteTitle: 'Zaproś członka',
        inviteCopy: 'Udostępnij ten link:',
        inviteExpires: 'Link wygaśnie za 7 dni',
        addManagedTitle: 'Dodaj członka rodziny',
        addManagedDesc: 'Dodaj osobę bez konta. Będzie można połączyć później.',
        name: 'Imię',
        role: 'Rola',
        uiMode: 'Tryb UI',
        emailOptional: 'Email (opcjonalnie)',
        color: 'Kolor',
        cancel: 'Anuluj',
        add: 'Dodaj',
        settingsTitle: 'Ustawienia członka',
        nickname: 'Pseudonim',
        remove: 'Usuń',
        save: 'Zapisz',
        toastInviteFail: 'Nie udało się utworzyć zaproszenia',
        toastCopied: 'Skopiowano link!',
        toastDelete: 'Rodzina usunięta',
        toastDeleteFail: 'Nie udało się usunąć rodziny',
        toastAddMember: 'Członek dodany!',
        toastAddMemberFail: 'Nie udało się dodać członka',
        toastUpdate: 'Zaktualizowano członka!',
        toastUpdateFail: 'Nie udało się zaktualizować członka',
        toastRemove: 'Członek usunięty',
        toastRemoveFail: 'Nie udało się usunąć członka',
        deleteConfirm: 'Czy na pewno usunąć "{{name}}"? Tej operacji nie można cofnąć.',
        removeConfirm: 'Usunąć tego członka z rodziny?',
        currentSet: 'ustawiono jako aktualną rodzinę',
      },
      join: {
        title: 'Zaproszenie do rodziny',
        subtitle: 'Zostałeś zaproszony do rodziny w MyFamily',
        accept: 'Akceptuj zaproszenie',
        joining: 'Dołączanie...',
        pleaseSignIn: 'Zaloguj się lub utwórz konto, aby dołączyć',
        signIn: 'Zaloguj',
        register: 'Zarejestruj',
        backHome: 'Wróć do strony głównej',
        success: 'Dołączyłeś do rodziny!',
        fail: 'Nie udało się dołączyć do rodziny',
      },
      todoBoards: {
        title: 'Tablice zadań',
        noneTitle: 'Brak tablic',
        noneDesc: 'Utwórz pierwszą tablicę',
        newBoard: 'Nowa tablica',
        createBoard: 'Utwórz tablicę',
        boardName: 'Nazwa tablicy',
        boardDesc: 'Opis',
        boardDescPlaceholder: 'Do czego służy ta tablica?',
        noFamilyTitle: 'Brak wybranej rodziny',
        noFamilyDesc: 'Wybierz lub utwórz rodzinę, aby zarządzać tablicami',
        goFamilies: 'Przejdź do rodzin',
        toastCreated: 'Tablica utworzona!',
        toastCreateFail: 'Nie udało się utworzyć tablicy',
      },
      todoBoard: {
        addTask: 'Dodaj zadanie',
        filters: {
          all: 'Wszystkie',
          todo: 'Do zrobienia',
          done: 'Zrobione',
        },
        emptyDoneTitle: 'Brak ukończonych zadań',
        emptyDoneDesc: 'Ukończ zadania, aby pojawiły się tutaj',
        emptyTitle: 'Brak zadań',
        emptyDesc: 'Dodaj pierwsze zadanie, aby zacząć',
        addTaskCta: 'Dodaj zadanie',
        assignedTo: 'Przydzielone do {{name}}',
        due: 'Termin {{date}}',
        modalTitle: 'Dodaj zadanie',
        taskTitle: 'Tytuł zadania',
        description: 'Opis',
        priority: 'Priorytet',
        low: 'Niski',
        medium: 'Średni',
        high: 'Wysoki',
        urgent: 'Pilny',
        cancel: 'Anuluj',
        create: 'Utwórz',
        toastAdded: 'Zadanie dodane!',
        toastAddFail: 'Nie udało się dodać zadania',
        toastDelete: 'Zadanie usunięte',
      },
      shoppingLists: {
        title: 'Listy zakupów',
        noneTitle: 'Brak list',
        noneDesc: 'Utwórz pierwszą listę zakupów',
        newList: 'Nowa lista',
        createList: 'Utwórz listę',
        listName: 'Nazwa listy',
        store: 'Sklep (opcjonalnie)',
        color: 'Kolor',
        noFamilyTitle: 'Brak wybranej rodziny',
        noFamilyDesc: 'Wybierz lub utwórz rodzinę, aby zarządzać listami',
        goFamilies: 'Przejdź do rodzin',
        toastCreated: 'Lista utworzona!',
        toastCreateFail: 'Nie udało się utworzyć listy',
        completed: 'Zakończona',
        itemsCount: '{{checked}}/{{total}} pozycji',
      },
      shoppingList: {
        progress: '{{checked}} z {{total}} pozycji',
        quickAddPlaceholder: 'Dodaj pozycję...',
        emptyTitle: 'Lista jest pusta',
        emptyDesc: 'Dodaj pozycje do listy zakupów',
        toBuy: 'Do kupienia',
        completed: 'Zakończone ({{count}})',
        addedBy: 'przez {{name}}',
        notes: 'Notatki',
        category: 'Kategoria',
        quantityUnit: '× {{quantity}} {{unit}}',
        modalTitle: 'Dodaj pozycję',
        itemName: 'Nazwa',
        quantity: 'Ilość',
        unit: 'Jednostka',
        notesLabel: 'Notatki',
        cancel: 'Anuluj',
        add: 'Dodaj',
        toastAdded: 'Dodano pozycję!',
        toastRemoved: 'Usunięto pozycję',
      },
      documents: {
        title: 'Dokumenty',
        upload: 'Wyślij',
        searchPlaceholder: 'Szukaj dokumentów...',
        noneTitle: 'Brak dokumentów',
        noneDesc: 'Wyślij pierwszy dokument',
        uploadCta: 'Wyślij dokument',
        noFamilyTitle: 'Brak wybranej rodziny',
        noFamilyDesc: 'Wybierz lub utwórz rodzinę, aby zarządzać dokumentami',
        goFamilies: 'Przejdź do rodzin',
        uploadedBy: 'przez {{name}}',
        toastUploaded: 'Dokument wysłany!',
        toastUploadFail: 'Nie udało się wysłać',
        toastDelete: 'Dokument usunięty',
        toastDownloadFail: 'Nie udało się pobrać',
        modalTitle: 'Wyślij dokument',
        selectFile: 'Wybierz plik do wysłania',
        uploading: 'Wysyłanie...',
        cancel: 'Anuluj',
        uploadBtn: 'Wyślij',
      },
      passwords: {
        title: 'Skarbiec haseł',
        searchPlaceholder: 'Szukaj haseł...',
        noneTitle: 'Brak haseł',
        noneDesc: 'Dodaj pierwsze hasło',
        addPassword: 'Dodaj hasło',
        noFamilyTitle: 'Brak wybranej rodziny',
        noFamilyDesc: 'Wybierz lub utwórz rodzinę, aby zarządzać hasłami',
        goFamilies: 'Przejdź do rodzin',
        reveal: 'Pokaż',
        hide: 'Ukryj',
        toastSaved: 'Hasło zapisane!',
        toastSaveFail: 'Nie udało się zapisać hasła',
        toastDelete: 'Hasło usunięte',
        toastCopy: 'Skopiowano!',
        toastGenerate: 'Wygenerowano hasło!',
        toastRevealFail: 'Nie udało się odsłonić hasła',
        modalTitle: 'Dodaj hasło',
        name: 'Nazwa',
        username: 'Nazwa użytkownika',
        email: 'Email',
        password: 'Hasło',
        url: 'URL',
        category: 'Kategoria',
        cancel: 'Anuluj',
        save: 'Zapisz',
        generate: 'Generuj',
      },
      calendar: {
        title: 'Kalendarz',
        addEvent: 'Dodaj wydarzenie',
        noFamilyTitle: 'Brak wybranej rodziny',
        noFamilyDesc: 'Wybierz lub utwórz rodzinę, aby zobaczyć kalendarz',
        goFamilies: 'Przejdź do rodzin',
        monthLabel: '{{month}} {{year}}',
        dayNames: ['Nd', 'Pn', 'Wt', 'Śr', 'Cz', 'Pt', 'So'],
        noEvents: 'Brak wydarzeń',
        googleTitle: 'Integracja z Google Calendar',
        googleDesc: 'Połącz kalendarz Google, aby synchronizować wydarzenia.',
        connectGoogle: 'Połącz Google Calendar',
      },
      notFound: {
        title: 'Strona nie znaleziona',
        desc: 'Strona, której szukasz, nie istnieje lub została przeniesiona.',
        backHome: 'Wróć do strony głównej',
      },
      authLayout: {
        brand: 'MyFamily',
        tagline: 'Zarządzanie rodziną',
        footer: '© 2024 MyFamily. Wszelkie prawa zastrzeżone.',
      },
      common: {
        settings: 'Ustawienia',
        manageAccount: 'Zarządzaj kontem i preferencjami',
        logout: 'Wyloguj',
        appInfo: 'MyFamily v1.0.0',
        madeWithLove: 'Stworzone z ❤️ dla rodzin',
      },
      settings: {
        account: 'Konto',
        preferences: 'Preferencje',
        devices: 'Urządzenia',
        editProfile: 'Edytuj profil',
        editProfileDesc: 'Zaktualizuj imię, email i avatar',
        changePassword: 'Zmień hasło',
        changePasswordDesc: 'Zaktualizuj hasło do konta',
        notifications: 'Powiadomienia',
        notificationsDescOn: 'Włączone',
        notificationsDescOff: 'Wyłączone',
        darkMode: 'Tryb ciemny',
        darkModeDesc: 'Zawsze włączony',
        theme: 'Motyw',
        themeDesc: 'Przełącz jasny/ciepły lub ciemny',
        themeLight: 'Jasny (ciepły)',
        themeDark: 'Ciemny',
        save: 'Zapisz',
        language: 'Język',
        languageDesc: 'Wybierz język',
        manageDevices: 'Zarządzaj urządzeniami',
        manageDevicesDesc: 'Przeglądaj i zarządzaj urządzeniami',
        languageLabel: 'Język',
        languages: {
          en: 'Angielski',
          pl: 'Polski',
          uk: 'Ukraiński',
        },
      },
    },
  },
  uk: {
    translation: {
      nav: {
        dashboard: 'Дашборд',
        families: 'Родини',
        todos: 'Дошки завдань',
        documents: 'Документи',
        passwords: 'Паролі',
        shopping: 'Покупки',
        calendar: 'Календар',
        settings: 'Налаштування',
        logout: 'Вийти',
      },
      auth: {
        welcomeBack: 'З поверненням',
        signInSubtitle: 'Увійдіть до свого акаунту, щоб продовжити',
        usernameOrEmail: 'Ім’я користувача або email',
        password: 'Пароль',
        signIn: 'Увійти',
        noAccount: 'Немає акаунту?',
        createOne: 'Створіть його',
        createAccount: 'Створити акаунт',
        joinSubtitle: 'Приєднуйтесь до MyFamily та організовуйте разом',
        firstName: "Ім'я",
        lastName: 'Прізвище',
        email: 'Email',
        username: 'Ім’я користувача',
        confirmPassword: 'Підтвердіть пароль',
        register: 'Створити акаунт',
        haveAccount: 'Вже є акаунт?',
        signInHere: 'Увійдіть',
        creating: 'Створення акаунту...',
        loginFailed: 'Не вдалося увійти',
        registrationFailed: 'Не вдалося зареєструватися',
        accountCreated: 'Акаунт створено!',
      },
      register: {
        title: 'Створити акаунт',
        subtitle: 'Приєднуйтесь до MyFamily та організовуйте разом',
        firstName: "Ім'я",
        lastName: 'Прізвище',
        email: 'Email',
        username: "Ім'я користувача",
        password: 'Пароль',
        confirmPassword: 'Підтвердіть пароль',
        create: 'Створити акаунт',
        haveAccount: 'Вже є акаунт?',
        signIn: 'Увійти',
        required: 'Обовʼязково',
        emailRequired: 'Потрібен email',
        emailInvalid: 'Невірна адреса email',
        usernameRequired: "Потрібно ім'я користувача",
        usernameMin: 'Мінімум 3 символи',
        passwordRequired: 'Потрібен пароль',
        passwordMin: 'Мінімум 8 символів',
        confirmRequired: 'Підтвердіть пароль',
        confirmMismatch: 'Паролі не співпадають',
        creating: 'Створення акаунту...',
      },
      dashboard: {
        greetingMorning: 'Доброго ранку',
        greetingAfternoon: 'Доброго дня',
        greetingEvening: 'Доброго вечора',
        noFamily: 'Немає родини',
        createFamilyCta: 'Створити родину',
        quickActions: {
          todos: 'Дошки завдань',
          documents: 'Документи',
          passwords: 'Паролі',
          shopping: 'Покупки',
          calendar: 'Календар',
          families: 'Родини',
        },
        recentActivity: 'Остання активність',
        noActivity: 'Немає активності',
        activityHint: 'Активність вашої родини з’явиться тут',
      },
      families: {
        title: 'Родини',
        subtitle: 'Керуйте своїми сімейними групами',
        create: 'Створити родину',
        noneTitle: 'Немає родин',
        noneDesc: 'Створіть першу родину або попросіть запрошення',
        nameLabel: 'Назва родини',
        descLabel: 'Опис (необовʼязково)',
        descPlaceholder: 'Короткий опис родини',
        cancel: 'Скасувати',
        creating: 'Створення...',
        createCta: 'Створити',
        selectFamily: 'Перейти до родин',
        membersCount: '{{count}} учасник',
        membersCount_plural: '{{count}} учасників',
        toastCreated: 'Родину створено!',
        toastCreateFail: 'Не вдалося створити родину',
      },
      familyDetail: {
        setCurrent: 'Зробити поточною',
        invite: 'Запросити',
        addMember: 'Додати учасника',
        members: 'Учасники',
        managed: 'керований',
        simpleUI: 'спрощений інтерфейс',
        inviteTitle: 'Запросити учасника',
        inviteCopy: 'Поділіться цим посиланням:',
        inviteExpires: 'Посилання дійсне 7 днів',
        addManagedTitle: 'Додати учасника родини',
        addManagedDesc: 'Додайте користувача без акаунту. Можна привʼязати пізніше.',
        name: "Ім'я",
        role: 'Роль',
        uiMode: 'Режим UI',
        emailOptional: 'Email (необовʼязково)',
        color: 'Колір',
        cancel: 'Скасувати',
        add: 'Додати',
        settingsTitle: 'Налаштування учасника',
        nickname: 'Нікнейм',
        remove: 'Видалити',
        save: 'Зберегти',
        toastInviteFail: 'Не вдалося створити запрошення',
        toastCopied: 'Посилання скопійовано!',
        toastDelete: 'Родину видалено',
        toastDeleteFail: 'Не вдалося видалити родину',
        toastAddMember: 'Учасника додано!',
        toastAddMemberFail: 'Не вдалося додати учасника',
        toastUpdate: 'Оновлено учасника!',
        toastUpdateFail: 'Не вдалося оновити учасника',
        toastRemove: 'Учасника видалено',
        toastRemoveFail: 'Не вдалося видалити учасника',
        deleteConfirm: 'Ви впевнені, що хочете видалити "{{name}}"? Це незворотно.',
        removeConfirm: 'Видалити цього учасника з родини?',
        currentSet: 'встановлено як поточну родину',
      },
      join: {
        title: 'Запрошення до родини',
        subtitle: 'Вас запросили до родини в MyFamily',
        accept: 'Прийняти запрошення',
        joining: 'Приєднання...',
        pleaseSignIn: 'Увійдіть або створіть акаунт, щоб приєднатись',
        signIn: 'Увійти',
        register: 'Зареєструватися',
        backHome: 'Повернутися додому',
        success: 'Ви приєдналися до родини!',
        fail: 'Не вдалося приєднатись до родини',
      },
      todoBoards: {
        title: 'Дошки завдань',
        noneTitle: 'Немає дошок',
        noneDesc: 'Створіть першу дошку',
        newBoard: 'Нова дошка',
        createBoard: 'Створити дошку',
        boardName: 'Назва дошки',
        boardDesc: 'Опис',
        boardDescPlaceholder: 'Для чого ця дошка?',
        noFamilyTitle: 'Немає вибраної родини',
        noFamilyDesc: 'Виберіть або створіть родину, щоб керувати дошками',
        goFamilies: 'Перейти до родин',
        toastCreated: 'Дошку створено!',
        toastCreateFail: 'Не вдалося створити дошку',
      },
      todoBoard: {
        addTask: 'Додати завдання',
        filters: {
          all: 'Усі',
          todo: 'До виконання',
          done: 'Виконано',
        },
        emptyDoneTitle: 'Немає виконаних завдань',
        emptyDoneDesc: 'Виконайте завдання, щоб побачити їх тут',
        emptyTitle: 'Немає завдань',
        emptyDesc: 'Додайте перше завдання, щоб почати',
        addTaskCta: 'Додати завдання',
        assignedTo: 'Призначено {{name}}',
        due: 'Термін {{date}}',
        modalTitle: 'Додати завдання',
        taskTitle: 'Назва завдання',
        description: 'Опис',
        priority: 'Пріоритет',
        low: 'Низький',
        medium: 'Середній',
        high: 'Високий',
        urgent: 'Терміновий',
        cancel: 'Скасувати',
        create: 'Створити',
        toastAdded: 'Завдання додано!',
        toastAddFail: 'Не вдалося додати завдання',
        toastDelete: 'Завдання видалено',
      },
      shoppingLists: {
        title: 'Списки покупок',
        noneTitle: 'Немає списків',
        noneDesc: 'Створіть перший список покупок',
        newList: 'Новий список',
        createList: 'Створити список',
        listName: 'Назва списку',
        store: 'Магазин (необовʼязково)',
        color: 'Колір',
        noFamilyTitle: 'Немає вибраної родини',
        noFamilyDesc: 'Виберіть або створіть родину, щоб керувати списками',
        goFamilies: 'Перейти до родин',
        toastCreated: 'Список створено!',
        toastCreateFail: 'Не вдалося створити список',
        completed: 'Завершено',
        itemsCount: '{{checked}}/{{total}} позицій',
      },
      shoppingList: {
        progress: '{{checked}} з {{total}} позицій',
        quickAddPlaceholder: 'Додайте позицію...',
        emptyTitle: 'Список порожній',
        emptyDesc: 'Додайте позиції до списку покупок',
        toBuy: 'До купівлі',
        completed: 'Завершено ({{count}})',
        addedBy: 'від {{name}}',
        notes: 'Нотатки',
        category: 'Категорія',
        quantityUnit: '× {{quantity}} {{unit}}',
        modalTitle: 'Додати позицію',
        itemName: 'Назва',
        quantity: 'Кількість',
        unit: 'Одиниця',
        notesLabel: 'Нотатки',
        cancel: 'Скасувати',
        add: 'Додати',
        toastAdded: 'Позицію додано!',
        toastRemoved: 'Позицію видалено',
      },
      documents: {
        title: 'Документи',
        upload: 'Завантажити',
        searchPlaceholder: 'Шукати документи...',
        noneTitle: 'Немає документів',
        noneDesc: 'Завантажте перший документ',
        uploadCta: 'Завантажити документ',
        noFamilyTitle: 'Немає вибраної родини',
        noFamilyDesc: 'Виберіть або створіть родину, щоб керувати документами',
        goFamilies: 'Перейти до родин',
        uploadedBy: 'від {{name}}',
        toastUploaded: 'Документ завантажено!',
        toastUploadFail: 'Не вдалося завантажити',
        toastDelete: 'Документ видалено',
        toastDownloadFail: 'Не вдалося завантажити файл',
        modalTitle: 'Завантажити документ',
        selectFile: 'Виберіть файл для завантаження',
        uploading: 'Завантаження...',
        cancel: 'Скасувати',
        uploadBtn: 'Завантажити',
      },
      passwords: {
        title: 'Сховище паролів',
        searchPlaceholder: 'Шукати паролі...',
        noneTitle: 'Немає паролів',
        noneDesc: 'Додайте перший пароль',
        addPassword: 'Додати пароль',
        noFamilyTitle: 'Немає вибраної родини',
        noFamilyDesc: 'Виберіть або створіть родину, щоб керувати паролями',
        goFamilies: 'Перейти до родин',
        reveal: 'Показати',
        hide: 'Сховати',
        toastSaved: 'Пароль збережено!',
        toastSaveFail: 'Не вдалося зберегти пароль',
        toastDelete: 'Пароль видалено',
        toastCopy: 'Скопійовано!',
        toastGenerate: 'Згенеровано пароль!',
        toastRevealFail: 'Не вдалося показати пароль',
        modalTitle: 'Додати пароль',
        name: 'Назва',
        username: "Ім'я користувача",
        email: 'Email',
        password: 'Пароль',
        url: 'URL',
        category: 'Категорія',
        cancel: 'Скасувати',
        save: 'Зберегти',
        generate: 'Згенерувати',
      },
      calendar: {
        title: 'Календар',
        addEvent: 'Додати подію',
        noFamilyTitle: 'Немає вибраної родини',
        noFamilyDesc: 'Виберіть або створіть родину, щоб переглядати календар',
        goFamilies: 'Перейти до родин',
        monthLabel: '{{month}} {{year}}',
        dayNames: ['Нд', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
        noEvents: 'Подій немає',
        googleTitle: 'Інтеграція з Google Calendar',
        googleDesc: 'Підключіть Google Calendar для синхронізації подій.',
        connectGoogle: 'Підключити Google Calendar',
      },
      notFound: {
        title: 'Сторінку не знайдено',
        desc: 'Сторінка не існує або була перенесена.',
        backHome: 'На головну',
      },
      authLayout: {
        brand: 'MyFamily',
        tagline: 'Керування родиною',
        footer: '© 2024 MyFamily. Всі права захищено.',
      },
      common: {
        settings: 'Налаштування',
        manageAccount: 'Керуйте обліковим записом і вподобаннями',
        logout: 'Вийти',
        appInfo: 'MyFamily v1.0.0',
        madeWithLove: 'Створено з ❤️ для сімей',
      },
      settings: {
        account: 'Обліковий запис',
        preferences: 'Налаштування',
        devices: 'Пристрої',
        editProfile: 'Редагувати профіль',
        editProfileDesc: 'Оновіть імʼя, email і аватар',
        changePassword: 'Змінити пароль',
        changePasswordDesc: 'Оновіть пароль облікового запису',
        notifications: 'Сповіщення',
        notificationsDescOn: 'Увімкнено',
        notificationsDescOff: 'Вимкнено',
        darkMode: 'Темний режим',
        darkModeDesc: 'Завжди увімкнено',
        theme: 'Тема',
        themeDesc: 'Світла/тепла чи темна',
        themeLight: 'Світла (тепла)',
        themeDark: 'Темна',
        save: 'Зберегти',
        language: 'Мова',
        languageDesc: 'Виберіть мову',
        manageDevices: 'Керування пристроями',
        manageDevicesDesc: 'Перегляд і керування пристроями',
        languageLabel: 'Мова',
        languages: {
          en: 'Англійська',
          pl: 'Польська',
          uk: 'Українська',
        },
      },
    },
  },
};

const storedLang = localStorage.getItem('i18n-lang') || 'en';

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: storedLang,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;

